// @flow
import { GEOCODER_LOAD_COMPLETIONS } from 'actions/geocoder';

export const INITIAL_STATE = {
  query: undefined,
  completions: { gmp: [], as: [], ap: [], ac: [] },
};

export default function reduce(
  state = INITIAL_STATE,
  { type, query, completions }
) {
  switch (type) {
    case GEOCODER_LOAD_COMPLETIONS:
      return {
        query,
        completions,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/geocoder.js